import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { useSearch } from "hooks/useSearch";
import { useValidateReload } from "hooks/useValidateReload";
import Snackbar from "components/Snackbar/Snackbar";
import { clearSnackbar, setSnackbar } from "redux/actions/search/searchActions";
import { Description } from "@material-ui/icons";
import {
  getGlobalInvoiceStatus,
  handleGlobalInvoiceStatusInputs,
} from "redux/actions/globalInvoiceStatus/globalInvoiceStatusAction";
import { columns } from "./columns";

const tableKey = "globalInvoiceStatus";
const loadings = ["loadingGlobalInvoiceStatus"];

function GlobalInvoiceStatusView() {
  const dispatch = useDispatch();
  const { date, station, invoices } = useSelector(
    ({ globalInvoiceStatus }) => globalInvoiceStatus,
  );
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { buildCompLoadings, buildTableConfig } = useSearch();
  const { isOpen, message, color } = useSelector(({ search }) => search);

  useValidateReload(loadings);

  useEffect(() => {
    buildCompLoadings(loadings);
    buildTableConfig(tableKey);
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!station?.id) {
      dispatch(setSnackbar("Falta seleccionar la planta"));
      return;
    }
    const [year, month] = String(date).split("-");
    dispatch(getGlobalInvoiceStatus(station.id, Number(month), Number(year)));
  };

  const handleCloseSnackbar = () => dispatch(clearSnackbar());

  return (
    <>
      <CardTable
        data={invoices}
        columns={columns}
        hasHeader
        blockBtn
        title="Facturas Globales Estatus"
        icon={<Description />}
        isLoading={isLoadingComp?.loadingGlobalInvoiceStatus}
        tableContent={
          <TableInputs
            reducer="globalInvoiceStatus"
            date
            monthType
            stations
            dispatchAction={handleGlobalInvoiceStatusInputs}
            submitAction={handleSubmit}
          />
        }
        tableKey={tableKey}
      />
      <Snackbar
        open={isOpen}
        place="tr"
        message={message}
        color={color}
        closeNotification={handleCloseSnackbar}
        close
      />
    </>
  );
}

export default React.memo(GlobalInvoiceStatusView);
